export const createStyles = (theme?: any) => ({
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    minWidth: 0,
    width: '100%',
  },
  accordion: {
    bgcolor: 'transparent',
    borderBottom: '1px solid',
    borderColor: 'divider',
    boxShadow: 'none',
    width: '100%',
    '&:before': { display: 'none' },
    '& .MuiAccordionSummary-root': {
      columnGap: '10px',
      minHeight: 0,
      px: 0,
      py: '20px',
    },
    '& .MuiAccordionSummary-root.Mui-expanded': { minHeight: 0 },
    '& .MuiAccordionSummary-content': { my: 0 },
    '& .MuiAccordionSummary-content.Mui-expanded': { my: 0 },
    '& .MuiAccordionSummary-content .MuiTypography-root': {
      color: 'text.primary',
      fontSize: '1rem',
      fontWeight: 500,
    },
    '& .MuiAccordionSummary-expandIconWrapper': {
      color: 'text.primary',
      mr: 0,
    },
    '& .MuiAccordionDetails-root': { p: 0 },
    '& .MuiAccordionDetails-root > .MuiBox-root': {
      maxHeight: 'none',
      p: '12px 0 16px',
    },
  },
  table: {
    bgcolor: 'background.paper',
    borderColor: 'divider',
    borderRadius: 2,
    overflow: 'hidden',
    width: '100%',
    '& table': { tableLayout: 'fixed' },
    '& button[aria-label="row actions"]': {
      height: '24px',
      width: '24px',
      p: 0,
      '& .MuiSvgIcon-root': { fontSize: '24px' },
    },
  },
  staticTable: {
    '& tbody tr:hover': { bgcolor: 'background.paper' },
  },
  tableHeader: {
    bgcolor: 'background.paper',
    borderBottom: 'none',
    color: 'text.primary',
    fontSize: '14px',
    fontWeight: 500,
    px: '12px',
    py: '12px',
    textAlign: 'left',
  },
  tableCell: {
    fontFamily: theme?.typography?.fontFamily,
    fontSize: '0.875rem',
    fontStyle: 'normal',
    fontWeight: theme?.typography?.fontWeightRegular ?? 400,
    letterSpacing: '0.17px',
    lineHeight: '150%',
    px: '12px',
  },
  studentIdentity: {
    alignItems: 'center',
    display: 'flex',
    gap: '12px',
    width: '100%',
  },
  tableNameButton: {
    background: 'none',
    border: 0,
    color: 'inherit',
    cursor: 'pointer',
    font: 'inherit',
    justifyContent: 'flex-start',
    p: 0,
    textAlign: 'left',
    textTransform: 'none',
    '&:hover': { background: 'none', border: 0 },
    '&:focus-visible': {
      borderRadius: '2px',
      outline: '2px solid',
      outlineColor: 'primary.main',
      outlineOffset: '2px',
    },
  },
  avatar: { flexShrink: 0, height: '40px', width: '40px' },
  name: {
    color: 'text.primary',
    fontFamily: theme?.typography?.fontFamily,
    fontSize: '0.875rem',
    fontStyle: 'normal',
    fontWeight: theme?.typography?.fontWeightRegular ?? 400,
    letterSpacing: '0.17px',
    lineHeight: '150%',
    minWidth: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  rowValue: {
    color: 'text.primary',
    fontFamily: theme?.typography?.fontFamily,
    fontSize: '0.875rem',
    fontStyle: 'normal',
    fontWeight: theme?.typography?.fontWeightRegular ?? 400,
    letterSpacing: '0.17px',
    lineHeight: '150%',
  },
  cards: { display: 'flex', flexDirection: 'column', gap: '12px' },
  card: {
    bgcolor: 'background.paper',
    border: '1px solid',
    borderColor: 'divider',
    borderRadius: 2,
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    gap: '6px',
    px: '16px',
    py: '12px',
    width: '100%',
  },
  clickableCard: {
    cursor: 'pointer',
    '&:focus-visible': {
      outline: '2px solid',
      outlineColor: 'primary.main',
      outlineOffset: '2px',
    },
  },
  cardHeader: {
    alignItems: 'flex-start',
    display: 'flex',
    gap: '8px',
    justifyContent: 'space-between',
    minHeight: '24px',
  },
  cardName: {
    color: 'text.primary',
    fontSize: '0.875rem',
    fontWeight: 500,
    overflowWrap: 'anywhere',
  },
  cardNameButton: {
    background: 'none',
    border: 0,
    color: 'text.primary',
    cursor: 'pointer',
    fontSize: '0.875rem',
    fontWeight: 500,
    justifyContent: 'flex-start',
    minWidth: 0,
    overflowWrap: 'anywhere',
    p: 0,
    textAlign: 'left',
    textTransform: 'none',
    '&:hover': { background: 'none', border: 0 },
    '&:focus-visible': {
      borderRadius: '2px',
      outline: '2px solid',
      outlineColor: 'primary.main',
      outlineOffset: '2px',
    },
  },
  detail: {
    color: 'text.secondary',
    fontSize: '14px',
    lineHeight: 1.45,
  },
  detailLabel: { color: 'text.primary', fontWeight: 500 },
  empty: { color: 'text.secondary', p: '16px 0' },
  nestedGroups: { display: 'flex', flexDirection: 'column', gap: '8px' },
  mobileGroup: {
    bgcolor: 'background.paper',
    border: '1px solid',
    borderColor:
      theme?.palette?.mode === 'dark' ? 'divider' : 'rgba(35, 31, 41, 0.16)',
    borderRadius: 2,
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    minWidth: 0,
    p: '16px',
    width: '100%',
  },
  groupChip: {
    alignSelf: 'flex-start',
    bgcolor: 'rgba(134, 123, 151, 1)',
    borderRadius: '100px',
    color: 'common.white',
    height: '24px',
    maxHeight: '24px',
    maxWidth: '128px',
    minHeight: '24px',
    width: '128px',
    '& .MuiChip-label': {
      fontFamily: theme?.typography?.fontFamily,
      fontSize: '0.8125rem',
      fontWeight: theme?.typography?.fontWeightRegular ?? 400,
      letterSpacing: '0.16px',
      lineHeight: '18px',
      px: '4px',
      py: '3px',
    },
  },
  mobileGroupInformation: {
    display: 'flex',
    flexDirection: 'column',
    mt: '4px',
    minWidth: 0,
  },
  mobileGroupName: {
    color: 'text.primary',
    fontFamily: theme?.typography?.fontFamily,
    fontSize: '0.875rem',
    fontWeight: theme?.typography?.fontWeightMedium ?? 500,
    letterSpacing: '0.1px',
    lineHeight: '157%',
    overflowWrap: 'anywhere',
  },
  mobileGroupDetail: {
    color: 'text.secondary',
    fontFamily: theme?.typography?.fontFamily,
    fontSize: '0.875rem',
    fontWeight: theme?.typography?.fontWeightMedium ?? 500,
    letterSpacing: '0.1px',
    lineHeight: '157%',
    overflowWrap: 'anywhere',
  },
  mobileGroupDetailLabel: {
    color: 'text.primary',
    fontWeight: 500,
  },
  mobileGroupActions: {
    display: 'flex',
    gap: '12px',
    mt: '8px',
    minWidth: 0,
    width: '100%',
  },
  mobileGroupAction: {
    alignItems: 'center',
    display: 'flex',
    flex: '1 1 auto',
    fontSize: '0.875rem',
    gap: '4px',
    justifyContent: 'center',
    minWidth: 0,
    whiteSpace: 'nowrap',
    '& .MuiSvgIcon-root': { flexShrink: 0 },
  },
  mobileGroupOpenAction: { px: '17px' },
  mobileGroupToggleAction: { px: '9.5px' },
  mobileGroupMembers: {
    mt: '12px',
    minWidth: 0,
    width: '100%',
  },
  groupHeader: {
    alignItems: 'center',
    display: 'grid',
    gridTemplateColumns: 'minmax(0, 62.5%) minmax(0, 37.5%)',
    minWidth: 0,
    width: '100%',
  },
  groupName: {
    color: 'text.primary',
    fontFamily: theme?.typography?.fontFamily,
    fontSize: '1rem',
    fontWeight: theme?.typography?.fontWeightMedium ?? 500,
    letterSpacing: '0.15px',
    lineHeight: '150%',
    minWidth: 0,
    overflowWrap: 'anywhere',
  },
  groupDetail: {
    color: 'text.secondary',
    fontFamily: theme?.typography?.fontFamily,
    fontSize: '0.875rem',
    fontWeight: theme?.typography?.fontWeightRegular ?? 400,
    letterSpacing: '0.17px',
    left: 'calc(59.8% - 5px)',
    lineHeight: '150%',
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    whiteSpace: 'nowrap',
  },
  groupActions: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'flex-end',
    minHeight: '24px',
    opacity: 0,
    transition: theme?.transitions?.create
      ? theme.transitions.create('opacity', {
          duration: theme.transitions.duration.shortest,
        })
      : 'opacity 150ms ease-in-out',
    width: '100%',
    '&:focus-within': { opacity: 1 },
  },
  groupOpenAction: {
    border: 0,
    color: 'secondary.light',
    gap: '4px',
    mr: '8px',
    pr: '8px',
    whiteSpace: 'nowrap',
    '&:hover': {
      backgroundColor: 'transparent',
      border: 0,
      color: 'secondary.light',
    },
  },
  nestedAccordion: {
    bgcolor: 'background.paper',
    border: '1px solid',
    borderColor: 'divider',
    borderRadius: '8px !important',
    boxShadow: 'none',
    '&:before': { display: 'none' },
    '& .Accordion-headerRow': {
      borderBottom: '1px solid',
      borderColor: 'divider',
      boxSizing: 'border-box',
      pr: { sm: '12px' },
    },
    '& .Accordion-headerRow:hover .group-actions': { opacity: 1 },
    '& .Accordion-headerRow > .MuiButtonBase-root': {
      pl: '14px',
      pr: 0,
      py: '24px',
    },
    '& .Accordion-headerRow > .MuiBox-root:last-child': {
      flex: '0 0 auto',
      minWidth: 'fit-content',
      width: 'auto',
    },
    '& .MuiAccordionSummary-content, & .MuiAccordionSummary-content > .MuiBox-root, & .MuiAccordionSummary-content .start-summary':
      {
        minWidth: 0,
        width: '100%',
      },
    '& .MuiAccordionDetails-root': { p: 0 },
    '& .MuiAccordionDetails-root > .MuiBox-root': {
      maxHeight: 'none',
      p: 0,
    },
    '& .MuiAccordionDetails-root > .MuiBox-root > .MuiBox-root': {
      border: 0,
      borderRadius: 0,
    },
  },
});
